import { createRouter, createWebHistory } from 'vue-router';

import NotFound from '@lib/pages/NotFound.vue';

import lib_routes from '@lib/router';
import { extensionRoutes } from '@lib/extensions';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			path: '/',
			component: () => import('@lib/layouts/Dashboard/Main.vue'),
			meta: { auth: true },
			redirect: '/dashboard',
			children: [
				// Example pages
				{ path: 'dashboard', name: 'Home', component: () => import('@/pages/Dashboard.vue') },
				{ path: 'bands', name: 'Bands', component: () => import('@/pages/Bands.vue') },
				{ path: 'bands/:band_id', name: 'Band', component: () => import('@/pages/Band/Band.vue') },
				{ path: 'timeslots', name: 'Timeslots', component: () => import('@/pages/Timeslots.vue') },
				{ path: 'stages', name: 'Stages', component: () => import('@/pages/Stages.vue') },
				{ path: 'stages/:stage_id/plan', name: 'StagePlan', component: () => import('@/pages/StagePlan.vue') },
				{
					path: 'stage_plan_items',
					name: 'StagePlanItems',
					component: () => import('@/pages/StagePlanItems.vue'),
				},
				{ path: 'shifts', name: 'Shifts', component: () => import('@/pages/Shifts.vue') },
				{
					path: 'stage_manager_shifts',
					name: 'Stage Manager Shifts',
					component: () => import('@/pages/StageManagerShifts.vue'),
				},
				{
					path: 'notifications',
					name: 'Notifications',
					component: () => import('@/pages/StageNotifications.vue'),
				},
				// The settings of an event: the lib's page, events/:id/settings, with the app's tabs (app.ts)
				...extensionRoutes(),
				// Its former address, the same page for the active event
				{
					path: 'event/settings',
					component: () => import('@lib/pages/Context/ContextSettings.vue'),
					props: { context: 'event' },
				},
				//
				// Example and reusable Admin pages
				{ path: 'admin/users', component: () => import('@lib/pages/Admin/Users.vue') },
				{ path: 'admin/events', component: () => import('@/pages/Admin/Events.vue') },
				{ path: 'admin/screens', component: () => import('@/pages/Admin/Screens.vue') },
				{ path: 'admin/settings', component: () => import('@lib/pages/Admin/Settings/Settings.vue') },
				{
					path: 'admin/webhook_incomings/:id',
					component: () => import('@lib/pages/Admin/Settings/WebhookIncomingRequests.vue'),
				},
				{
					path: 'admin/webhook_outgoings/:id',
					component: () => import('@lib/pages/Admin/Settings/WebhookOutgoingRequests.vue'),
				},
				{ path: 'admin/maintenance', component: () => import('@lib/pages/Maintenance/Maintenance.vue') },
				{ path: 'admin/development', component: () => import('@lib/pages/Development/Development.vue') },
				//
				// User profile pages
				{ path: 'me', name: 'Profile', component: () => import('@lib/pages/Me/Me.vue') },
				//
				{
					path: '/no-event-available',
					name: 'NoContextAvailable',
					component: () => import('@lib/pages/NoEventAvailable.vue'),
				},
				{
					path: ':pathMatch(.*)*',
					name: '404',
					component: NotFound,
				},
			],
		},
		...lib_routes,
	],
});

export default router;
